const NAMESPACE = "SPLITPROFILELIST";
const actionType = type => `${NAMESPACE}_${type}`;

export const splitProfileListConstants = {
	SET_SORTING: actionType("SET_SORTING"),
	SET_PAGING: actionType("SET_PAGING"),
};
